import { httpClient } from "./httpClient";

const getAllWork = () => {
  return httpClient.get("dataWork");
};

export default {
  getAllWork,
};
